/*
 * 百舸云平台权限配置 - 平台权限
 *
 * name                     应用名称
 * version                  应用版本  1.0.0 开始
 * menus                    全部菜单  Array
 *   name                   菜单标识
 *   title                  菜单名称
 *   views                  二级菜单
 *     pc                   pc端  Array
 *       name               菜单标识
 *       title              菜单名称
 *       haveMenuSubpage    一级菜单有子页面
 *       auth               功能权限
 *         name             权限名称
 *         permission       权限值  菜单标识_菜单标识_功能
 *         haveSubpage      二级菜单有子页面
 *         pages            子页面标识  Array
 *
 *     mobile               移动端  Array
 */

export default {
  name: 'BaiGeYun',
  version: '1.0.0',
  menus: [
    {
      name: 'overview',
      title: '概况总览',
      views: {
        pc: [
          {
            name: 'overview',
            title: '概况总览',
            auth: [
              {
                name: '查看',
                permission: 'overview_overview_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'equipmentCenter',
      title: '设备中心',
      views: {
        pc: [
          {
            name: 'productManage',
            title: '产品管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'equipmentCenter_productManage_view',
                haveSubpage: true,
                pages: ['productDetail']
              },
              {
                name: '新增产品',
                permission: 'equipmentCenter_productManage_add'
              },
              {
                name: '产品类别管理',
                permission: 'equipmentCenter_productManage_category'
              },
              {
                name: '管理设备',
                permission: 'equipmentCenter_productManage_manageDevice'
              },
              {
                name: '同步信息',
                permission: 'equipmentCenter_productManage_syncInfo'
              },
              {
                name: '复制',
                permission: 'equipmentCenter_productManage_copy'
              },
              {
                name: '删除',
                permission: 'equipmentCenter_productManage_delete'
              }
            ]
          },
          {
            name: 'deviceManage',
            title: '设备管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'equipmentCenter_deviceManage_view',
                haveSubpage: true,
                pages: ['deviceDetail']
              },
              {
                name: '新增设备',
                permission: 'equipmentCenter_deviceManage_add'
              },
              {
                name: '同步信息',
                permission: 'equipmentCenter_deviceManage_syncInfo'
              },
              {
                name: '启用 / 禁用设备',
                permission: 'equipmentCenter_deviceManage_use'
              },
              {
                name: '召回设备',
                permission: 'equipmentCenter_deviceManage_callback'
              },
              {
                name: '分享设备',
                permission: 'equipmentCenter_deviceManage_share'
              },
              {
                name: '复制设备',
                permission: 'equipmentCenter_deviceManage_copy'
              },
              {
                name: '地址映射',
                permission: 'equipmentCenter_deviceManage_address'
              },
              {
                name: '删除设备',
                permission: 'equipmentCenter_deviceManage_delete'
              },
              {
                name: '编辑设备',
                permission: 'equipmentCenter_deviceManage_edit'
              }
            ]
          },
          {
            name: 'productLineManage',
            title: '产线管理',
            auth: [
              {
                name: '查看',
                permission: 'equipmentCenter_productLineManage_view',
                haveSubpage: true,
                pages: ['productLineDetail']
              },
              {
                name: '新增产线',
                permission: 'equipmentCenter_productLineManage_add'
              },
              {
                name: '编辑产线',
                permission: 'equipmentCenter_productLineManage_edit'
              },
              {
                name: '删除产线',
                permission: 'equipmentCenter_productLineManage_delete'
              },
              {
                name: '分享产线',
                permission: 'equipmentCenter_productLineManage_share'
              },
              {
                name: '召回产线',
                permission: 'equipmentCenter_productLineManage_callback'
              },
              {
                name: '更换设备',
                permission: 'equipmentCenter_productLineManage_changeDevice'
              },
              {
                name: '移除设备',
                permission: 'equipmentCenter_productLineManage_removeDevice'
              }
            ]
          },
          {
            name: 'deviceGroup',
            title: '设备分组',
            auth: [
              {
                name: '查看',
                permission: 'equipmentCenter_deviceGroup_view'
              },
              {
                name: '自定义分组管理',
                permission: 'equipmentCenter_deviceGroup_customerGroup'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'gatewayManage',
      title: '网关管理',
      views: {
        pc: [
          {
            name: 'gatewayManage',
            title: '网关管理',
            haveMenuSubpage: true,
            auth: [
              {
                name: '查看 / 详情',
                permission: 'gatewayManage_gatewayManage_view',
                haveSubpage: true,
                pages: ['gatewayDetail']
              },
              {
                name: '网关入库',
                permission: 'gatewayManage_gatewayManage_entry'
              },
              {
                name: 'HiVPN',
                permission: 'gatewayManage_gatewayManage_HiVPN'
              },
              // {
              //   name: 'GRMP',
              //   permission: 'gatewayManage_gatewayManage_GRMP'
              // },
              {
                name: '删除',
                permission: 'gatewayManage_gatewayManage_delete'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'organizationManage',
      title: '组织机构',
      views: {
        pc: [
          {
            name: 'companyManage',
            title: '企业管理',
            auth: [
              {
                name: '查看',
                permission: 'organizationManage_companyManage_view'
              },
              {
                name: '修改',
                permission: 'organizationManage_companyManage_modify'
              }
            ]
          },
          {
            name: 'userManage',
            title: '用户管理',
            auth: [
              {
                name: '查看',
                permission: 'organizationManage_userManage_view'
              },
              {
                name: '新增部门 / 编辑部门',
                permission: 'organizationManage_userManage_addAndModifyOrganization'
              },
              {
                name: '删除部门',
                permission: 'organizationManage_userManage_deleteOrganization'
              },
              {
                name: '用户账号管理',
                permission: 'organizationManage_userManage_userAccountManage'
              }
            ]
          },
          {
            name: 'roleManage',
            title: '角色管理',
            auth: [
              {
                name: '查看',
                permission: 'organizationManage_roleManage_view'
              },
              {
                name: '新增角色 / 编辑角色',
                permission: 'organizationManage_roleManage_addAndModify',
                haveSubpage: true,
                pages: ['addOrModifyRole']
              },
              {
                name: '推送设置',
                permission: 'organizationManage_roleManage_pushSet'
              },
              {
                name: '启用 / 禁用',
                permission: 'organizationManage_roleManage_onAndOff'
              },
              {
                name: '删除',
                permission: 'organizationManage_roleManage_delete'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'customerManage',
      title: '客户管理',
      views: {
        pc: [
          {
            name: 'customerManage',
            title: '客户管理',
            haveMenuSubpage: true,
            auth: [
              {
                name: '查看 / 详情',
                permission: 'customerManage_customerManage_view',
                haveSubpage: true,
                pages: ['viewCustomer']
              },
              {
                name: '新增客户',
                permission: 'customerManage_customerManage_add'
              },
              {
                name: '设备管理',
                permission: 'customerManage_customerManage_deviceManage'
              },
              {
                name: '启用 / 禁用',
                permission: 'customerManage_customerManage_onAndOff'
              },
              {
                name: '重置密码',
                permission: 'customerManage_customerManage_resetPassword'
              },
              {
                name: '删除',
                permission: 'customerManage_customerManage_delete'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'dataLargeScreen',
      title: '数据大屏',
      views: {
        pc: [
          {
            name: 'my',
            title: '我的大屏',
            auth: [
              {
                name: '查看',
                permission: 'dataLargeScreen_my_view'
              },
              {
                name: '操作',
                permission: 'dataLargeScreen_my_operate'
              }
            ]
          },
          {
            name: 'template',
            title: '模板中心',
            auth: [
              {
                name: '查看',
                permission: 'dataLargeScreen_template_view'
              }
            ]
          },
          {
            name: 'dataSource',
            title: '数据源',
            auth: [
              {
                name: '查看',
                permission: 'dataLargeScreen_dataSource_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'spaceManage',
      title: '空间管理',
      views: {
        pc: [
          {
            name: 'spaceManage',
            title: '空间管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'spaceManage_spaceManage_view'
              },
              {
                name: '清除数据',
                permission: 'spaceManage_spaceManage_clearData'
              },
              {
                name: '预警设置',
                permission: 'spaceManage_spaceManage_alarmSet'
              },
              {
                name: '刷新',
                permission: 'spaceManage_spaceManage_refresh'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'smsManage',
      title: '短信管理',
      views: {
        pc: [
          {
            name: 'smsOverview',
            title: '短信概况',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'smsManage_smsOverview_view'
              },
              {
                name: '重新发送',
                permission: 'smsManage_smsOverview_resend'
              },
              {
                name: '预警设置',
                permission: 'smsManage_smsOverview_warnSet'
              }
            ]
          },
          {
            name: 'smsPackageManage',
            title: '套餐管理',
            auth: [
              {
                name: '查看',
                permission: 'smsManage_smsPackageManage_view'
              },
              {
                name: '新增套餐 / 编辑套餐',
                permission: 'smsManage_smsPackageManage_addAndModify'
              },
              {
                name: '上架 / 下架',
                permission: 'smsManage_smsPackageManage_onAndOff'
              }
            ]
          },
          {
            name: 'smsSalesRecords',
            title: '销售记录',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'smsManage_smsSalesRecords_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'iotCardManage',
      title: '物联卡管理',
      views: {
        pc: [
          {
            name: 'cardList',
            title: '卡片列表',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'iotCardManage_cardList_view'
              },
              {
                name: '续费套餐',
                permission: 'iotCardManage_cardList_rebuy'
              },
              {
                name: '预警设置',
                permission: 'iotCardManage_cardList_warnSet'
              }
            ]
          },
          {
            name: 'iotPackageManage',
            title: '套餐管理',
            auth: [
              {
                name: '查看',
                permission: 'iotCardManage_iotPackageManage_view'
              },
              {
                name: '编辑',
                permission: 'iotCardManage_iotPackageManage_modify'
              },
              {
                name: '上架 / 下架',
                permission: 'iotCardManage_iotPackageManage_onAndOff'
              }
            ]
          },
          {
            name: 'iotSalesRecords',
            title: '销售记录',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'iotCardManage_smsSalesRecords_view'
              }
            ]
          },
          {
            name: 'renewalRecords',
            title: '续费记录',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'iotCardManage_renewalRecords_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'workorderManage',
      title: '工单管理',
      views: {
        pc: [
          {
            name: 'workorderManage',
            title: '工单管理',
            haveMenuSubpage: true,
            auth: [
              {
                name: '查看 / 详情',
                permission: 'workorderManage_workorderManage_view',
                haveSubpage: true,
                pages: ['outWorkorder']
              },
              {
                name: '派单',
                permission: 'workorderManage_workorderManage_assign'
              },
            ]
          }
        ],
        mobile: []
      },
    },
    {
      name: 'sendMessage',
      title: '发送消息',
      views: {
        pc: [
          {
            name: 'sendMessage',
            title: '发送消息',
            auth: [
              {
                name: '查看',
                permission: 'sendMessage_sendMessage_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'systemManage',
      title: '系统管理',
      views: {
        pc: [
          {
            name: 'systemLogs',
            title: '系统日志',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'systemManage_systemLogs_view'
              }
            ]
          },
          {
            name: 'systemSet',
            title: '系统设置',
            auth: [
              {
                name: '查看',
                permission: 'systemManage_systemSet_view'
              },
              {
                name: '基本设置',
                permission: 'systemManage_systemSet_basicSet'
              },
              {
                name: '安全设置',
                permission: 'systemManage_systemSet_safetySet'
              },
              {
                name: '运维设置',
                permission: 'systemManage_systemSet_operationsSet'
              },
              {
                name: '登录页设置',
                permission: 'systemManage_systemSet_loginSet'
              }
            ]
          },
          {
            name: 'mobileSetting',
            title: '移动端设置',
            auth: [
              {
                name: '查看',
                permission: 'mobileSetting_mobileSetting_view'
              },
              {
                name: '基本信息',
                permission: 'mobileSetting_mobileSetting_basicSet'
              },
              {
                name: '广告图管理',
                permission: 'mobileSetting_mobileSetting_bannerSet'
              },
              {
                name: '关于我们',
                permission: 'mobileSetting_mobileSetting_aboutSet'
              }
            ]
          }
        ],
        mobile: []
      }
    }
    // {
    //   name: 'mobileSetting',
    //   title: '移动端设置',
    //   views: {
    //     pc: [
    //       {
    //         name: 'mobileSetting',
    //         title: '移动端设置',
    //         auth: [
    //           {
    //             name: '查看',
    //             permission: 'mobileSetting_mobileSetting_view'
    //           },
    //           {
    //             name: '基本信息',
    //             permission: 'mobileSetting_mobileSetting_basicSet'
    //           },
    //           {
    //             name: '广告图管理',
    //             permission: 'mobileSetting_mobileSetting_bannerSet'
    //           },
    //           {
    //             name: '关于我们',
    //             permission: 'mobileSetting_mobileSetting_aboutSet'
    //           }
    //         ]
    //       }
    //     ],
    //     mobile: []
    //   }
    // }
  ]
};
